import { useTranslation } from 'react-i18next'

import { FormModal, formValidationSchemaNoChanged } from '../../../Form'
import { MODAL_HEADER_VARIANT } from '../../../Modal'

import { EMAIL_COPY_TO_ENTITY_FILTER_MODAL_INITIAL_VALUES } from './EmailCopyToEntityFilterModal.constants'
import { EmailCopyToEntityFilterModalFields } from './EmailCopyToEntityFilterModalFields'

function EmailCopyToEntityFilterModal({
  getValidationSchema = formValidationSchemaNoChanged,
  initialValues = EMAIL_COPY_TO_ENTITY_FILTER_MODAL_INITIAL_VALUES,
  onClose,
  onSubmit,
}) {
  const { t } = useTranslation()

  const validationSchema = getValidationSchema({ initialValues })

  return (
    <FormModal
      Fields={EmailCopyToEntityFilterModalFields}
      containerProps={{ headerVariant: MODAL_HEADER_VARIANT.EDIT }}
      formBodyProps={{
        submitButtonText: t('Modal.ApplyFilterBtnKey'),
        withNotifications: true,
      }}
      formTitle='Email.EmailCopyToEntityFilterModalTitleKey'
      initialValues={initialValues}
      validationSchema={validationSchema}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  )
}

export default EmailCopyToEntityFilterModal
